import { render, staticRenderFns } from "./SlideMenu.vue?vue&type=template&id=0fe6c696&scoped=true"
import script from "./SlideMenu.vue?vue&type=script&lang=js"
export * from "./SlideMenu.vue?vue&type=script&lang=js"
import style0 from "./SlideMenu.vue?vue&type=style&index=0&id=0fe6c696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe6c696",
  null
  
)

export default component.exports